import { z } from 'zod';

export const templateBaseSchema = z.object({
  id: z.string(),
});

export const templateNamedWidgetSchema = templateBaseSchema.extend({
  name: z.string(),
  showName: z.boolean().default(true),
});

// NOTE: 有調整 Canvas 內欄位時，要到 src/features/form-system/utils/migrate-component-content.ts 同步調整相關欄位邏輯。
const templateGroupWidgetSchema = templateBaseSchema.extend({
  /**
   * 群組父節點
   */
  parentId: z.string().nullable(),
  /**
   * 群組層級
   * - 0: root（或未分組）
   * - 1: 第一層子節點
   * - 2: 第二層子節點（目前上限）
   */
  level: z.number().int().min(0).max(2),
  childIds: z.array(z.string()),
  layoutDirection: z.enum(['vertical', 'horizontal']),
});

export const templateComponentCanvasSchema = templateGroupWidgetSchema.extend({
  x: z.number(),
  y: z.number(),
  w: z.number().min(1).max(24),
  h: z.number(),
});

export type TemplateComponentCanvas = z.infer<
  typeof templateComponentCanvasSchema
>;
